import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {DataImportEditMailModalComponent} from '../../data-import-edit-mail-modal/data-import-edit-mail-modal.component';
import {Form, NgForm} from '@angular/forms';
import {ExcSigninService} from "exc-signin";

@Component({
  selector: 'app-modal-dealer-edit',
  templateUrl: './modal-dealer-edit.component.html',
  styles: []
})
export class ModalDealerEditComponent extends ExcTranslation implements OnInit {
  @ViewChild('DealerForm', {read: NgForm}) DealerForm;
  data = {DealerLevel1: null, DealerLevel2: null, DealerLevel3: null, DealerRating: null, DealerName: null,
          DealerCountry: null, DealerZip: null, DealerCity: null, DealerStreet: null, DealerPhone: null,
          DealerEmail: null, DealerDocumentTreat: null, DealerGroupCheck: null, DealerInactive: null, DealerID: null, DealerCategory: null,
          DealerComment: null, DealerWV: null, DealerKB: null, DealerHFB: null};
  docOptions = [
    {value: null, text: '-', selected: false},
    {value: 1, text: this.getGlobal('Enumeration.DocumentTreat_1'), selected: false},
    {value: 2, text: this.getGlobal('Enumeration.DocumentTreat_2'), selected: false},
    {value: 3, text: this.getGlobal('Enumeration.DocumentTreat_3'), selected: false},
    {value: 4, text: this.getGlobal('Enumeration.DocumentTreat_4'), selected: false},
    {value: 5, text: this.getGlobal('Enumeration.DocumentTreat_5'), selected: false},
    {value: 6, text: this.getGlobal('Enumeration.DocumentTreat_6'), selected: false}
  ];
  addMore = false;
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService, private  cdr: ChangeDetectorRef,private excSec: ExcSigninService) {
    super();
  }
  showEditMail(e) {
    const _self = this;
    e.stopPropagation();
    let title = this.getRessource('newDealer');
    if (this.overlayConfig.data.DealerName !== undefined && this.overlayConfig.data.DealerName !== null) {
      title = this.overlayConfig.data.DealerName;
    }
    ExcCoreModule.showModal(DataImportEditMailModalComponent, null, 'l', {Recipients: _self.data.DealerEmail, AllowNull: true, Title: title}, false, null).subscribe(ret => {
      if (ret && ret.proceed === true) {
          _self.data.DealerEmail = ret.Recipients;
      }
    });
  }

  setDocTreat(e) {
    this.data.DealerDocumentTreat = e;
  }
  hasChanges() {
    const _self = this;
    // if (this.DealerForm.valid === true) {
    //   return true;
    // }
    for (const key of Object.keys(_self.data)) {
      if (_self.data[key] !== _self.overlayConfig.data[key]) {
        return true;
      }
    }
    return false;
  }
  setValue(val) {
    this.data[val.field] = val.value === '' ? null : val.value;
    this.cdr.detectChanges();
  }
  proceed() {
    const _self = this;
    _self.overlayRef.close({proceed: true, dealer: _self.data, addMore: _self.addMore});
  }

  ngOnInit() {
    const _self = this;
    console.log(_self.data);

    Object.assign(_self.data, _self.overlayConfig.data);
    if (_self.overlayConfig.data['IsFirstCall'] === true) {
      // Erster Call ohne Flag
      _self.addMore = false;
    } else {
      // Alle anderen CAlls mit Flag
      _self.addMore = this.overlayConfig.data['AddMore'];
    }
  }
  ratingChangeDetect(rating) {
    this.data.DealerRating = rating;
}
  catChangeDetect(cat) {
    this.data.DealerCategory = cat;
  }

  checkGroupCheck($event: any) {
    const _self = this;
    _self.data.DealerGroupCheck = $event;
    // console.log( '_self.data.DealerGroupCheck => ' + _self.data.DealerGroupCheck);
  }
  checkDealerInactive($event: any) {
    const _self = this;
    _self.data.DealerInactive = $event;
    // console.log( '_self.data.DealerInactive => ' + _self.data.DealerInactive);
  }
}
